function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M3.48581 5.07692C5.89359 2.755 13.1999 -0.495682 19.8421 5.07692",
  stroke: "#627080",
  strokeWidth: 1.5,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M3 9.44938C3.79375 7.88393 6.6622 4.75302 11.786 4.75302C16.9098 4.75302 19.7235 7.88393 20.4899 9.44938",
  stroke: "#627080",
  strokeWidth: 1.5,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M5.67207 20.7854C4.97032 19.9487 3.80972 17.6761 3.80972 14.9555C3.80972 11.5547 6.88665 7.26315 11.502 7.26315C16.1174 7.26315 20.486 11.114 19.4373 16.0081C18.7085 19.4089 14.9806 18.2753 14.579 15.7652C14.2292 13.5789 13.7692 12.2834 11.7449 12.2834C10.7548 12.2834 8.98885 13.0931 8.98885 15.7652C9.00329 17.5419 10.1255 20.4615 13.9312 21.919",
  stroke: "#627080",
  strokeWidth: 1.5,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M11.664 14.7935C11.61 16.386 12.4899 19.7166 16.4413 20.2996",
  stroke: "#627080",
  strokeWidth: 1.5,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "M9.63968 22C8.42511 20.9474 6.40082 18.3725 6.40082 15.1984C6.40082 11.2308 9.80163 9.69232 11.8259 9.69232C13.8502 9.69232 17.0081 11.3118 17.0081 15.2794",
  stroke: "#627080",
  strokeWidth: 1.5,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

const SvgFingerprint = ({
  svgRef,
  title,
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  width: 24,
  height: 24,
  viewBox: "0 0 24 24",
  fill: "none",
  ref: svgRef
}, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref, _ref2, _ref3, _ref4, _ref5);

const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgFingerprint, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/Fingerprint.cce110ef.svg";
export { ForwardRef as ReactComponent };